













import { chatLogIsCurrentlyAtBottom, scrollToBottomInChatLog } from "@/views/modules/messaging-inbox/useChat";
import { defineComponent, ref } from "@vue/composition-api";
import { BButton } from "bootstrap-vue";

export default defineComponent({
    components: {
        BButton,
    },
    setup() {
        const scrollToBottomButtonVisible = ref(!chatLogIsCurrentlyAtBottom.value);

        const handleShowScrollToBottomButton = (isVisible: boolean): void => {
            chatLogIsCurrentlyAtBottom.value = isVisible;
        };

        return {
            chatLogIsCurrentlyAtBottom,
            scrollToBottomInChatLog,
            scrollToBottomButtonVisible,
            handleShowScrollToBottomButton,
        };
    },
});
